import { useContext, useEffect } from 'react';

import { Layout } from '@/components/Layout/Layout';
import { Main } from '@/components/Main/Main';
import { Section } from '@/components/Section/Section';
// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';
// Modules
import { isPur, isSmart, isSupporter, setInnerHTML } from '@/lib/util';

const ConfirmationPage = () => {
  const [state, dispatch] = useContext(Context);

  useEffect(() => {
    void (async () => {
      const { setTitle } = await import('@/lib/util');
      setTitle('Bestätigung');
    })();

    const sessionState = JSON.parse(sessionStorage.getItem('sessionData') ?? '');

    if (sessionState) {
      dispatch({
        type: ActionTypes.restoreFromStorage,
        payload: sessionState
      });
    }

    dispatch({
      type: ActionTypes.setCurrentPage,
      payload: {
        key: 'currentPage',
        value: 'errorPage'
      }
    });

    dispatch({
      type: ActionTypes.showProductOnRight,
      payload: false
    });
  }, [dispatch]);

  const supporter = isSupporter(state.bundle);

  const heading = supporter ? 'Vielen Dank für Ihre Unterstützung' : 'Vielen Dank für Ihre Bestellung';

  const emailPlaceholder = state?.user?.email ? state.user.email : 'Ihre E-Mail-Adresse';

  const body = supporter
    ? `Als STANDARD Unterstützer:in leisten Sie einen wichtigen Beitrag zur Finanzierung des STANDARD. Sie erhalten in Kürze eine Bestätigung an ${emailPlaceholder} mit allen Informationen zu Ihrer Unterstützung.`
    : `Mit Ihrem Abo leisten Sie einen wichtigen Beitrag zur Finanzierung des STANDARD. Sie erhalten in Kürze eine Bestätigung an ${emailPlaceholder} mit allen Informationen zu Ihrem Abonnement.`;

  const supportEmail = supporter ? 'meinbeitrag@derStandard.at' : 'digitalabo@derStandard.at';

  const outroText = () => {
    if (!state.bundle) return '';

    switch (true) {
      case isPur(state.bundle):
        return '<p>Jetzt <a href="https://www.derstandard.at">derStandard.at</a> PUR genießen.</p>';

      case isSmart(state.bundle):
        return `
                    <p><strong>Jetzt STANDARD SMART genießen.</strong></p>
                    <div><a href="${import.meta.env.VITE_APP_SMART_RESSORT_URL}" class="form--button form--button-cta">Zum Ressort</a></div>
                `;

      case isSupporter(state.bundle):
        return '<p>Weiterlesen auf <a href="https://www.derstandard.at">derStandard.at</a></p>';

      default:
        return '';
    }
  };

  return (
    <Layout className="layout-split">
      <Main>
        <Section className="section-confirmation">
          <h1>{heading}</h1>

          <p dangerouslySetInnerHTML={setInnerHTML(body)}></p>
          <p>
            Für etwaige Rückfragen wenden Sie sich bitte an das Aboservice-Team unter <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
          </p>

          {state?.order?.orderId ? <p>Bestellnummer: {state.order.orderId}</p> : null}

          <div dangerouslySetInnerHTML={setInnerHTML(outroText())}></div>
        </Section>
      </Main>
    </Layout>
  );
};

export default ConfirmationPage;
